module.exports = __webpack_public_path__ + "static/img/202.8e60344.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/202.png
// module id = zfPk
// module chunks = 0